const createNonPropagatingEventHandler = (handler: (event: React.MouseEvent<HTMLElement>) => void) => {
  return (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    handler(event);
  };
};

export default createNonPropagatingEventHandler;
